import Api from '../Api';

import { url } from './config';
import { Visa } from './model';

class ExtendedApi extends Api<Visa> {}

const api = new ExtendedApi(url);

export default api;
